<app-advertising-form
  [edit]="false"
  [create]="true"
  [delete]="false"
  [details]="false"
  [access]="access()"
></app-advertising-form>
